var lazyList = require('ember-lazy-list')
var BodyViewMixin = require('./body-view-mixin')
var LazyItemView = require('./lazy-item-view')

module.exports = lazyList.LazyListView.extend(BodyViewMixin, {
    itemViewClass: LazyItemView
})
